import React, { useEffect, useState } from 'react';
import { Col } from "react-bootstrap";
import { useSelector } from 'react-redux';
import Icon from "components/Icons/Icon";
import Select, { components } from 'react-select';

import { useIsMounted } from 'components/Common/CustomHooks/useIsMounted';
import { darkModeSelectStyles } from "components/Common/CustomStyles/darkModeSelectStyles";

import conxtdOut from 'apis/conxtdOut';

import { _ } from "lodash";

import './AddSiteAsset.scss';

// Custom Category Select Options:
const CategoryCustomOption = (props) => {
  const { data } = props;
  return (
    <components.Option {...props}>
      <div className='d-flex align-items-center pr-1'>
        <span className='asset-category-icon'>
          <Icon className={`${!data.icon ? 'far fa-square' : data.icon}`} />
        </span>
        <span>{data.label}</span>
      </div>
    </components.Option>
  );
};
// ------------------------------------------------------------------|

// asset category dropdown selection component
const CategorySelection = ({ companyId, handleSetCategoryId, handleSetCategoryName, handleSetCustomFields, handleCategorySelectionInvalid, message = "" }) => {
  const darkMode = useSelector(state => state.app.darkMode);

  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);

  const isMounted = useIsMounted();
  
  useEffect(() => {
    if (!isMounted) { return };

    if (companyId) {
      const categories = conxtdOut.get(`/company-assets/company-assets/${companyId}`)
      categories.then((res) => {
        if (!res?.data) { return };
        const data = res?.data;
        if (Array.isArray(data) && data.length > 0) {
          const options = data.map(category => (!category.id || !category.name) ? null : (
            { label: category.name ?? '', 
              value: category.id, icon: category.icon ?? '', 
              customFields: category.company_asset_fields.filter(field => field.default === false) ?? []
            }
          ));
          setCategoryOptions(options);
        }
      })
      return;
    }
  }, [companyId])
  
  useEffect(() => {
    if (!isMounted) { return };
    handleSetCategoryId(selectedCategory?.[0]?.value ?? null)
    handleSetCategoryName?.(selectedCategory?.[0]?.label ?? null)
  }, [selectedCategory])
  
  useEffect(() => {
    if (!isMounted) { return };
    handleSetCustomFields?.(selectedCategory?.[0]?.customFields ?? [])
  }, [selectedCategory])

  useEffect(() => {
    handleCategorySelectionInvalid?.(Array.isArray(selectedCategory) && selectedCategory.length < 1);
  }, [selectedCategory])

  return (
    <div className={`${darkMode ? 'darkMode' : ''} w-100`}>
      <Col className={`d-flex flex-column p-0`}>
        <span className='d-flex flex-column'>
          {message ?
            <p>{message}</p>
          :
            <p>Select the <span className='add-asset-sub-title'>category</span> to assign this new asset to:</p>
          }
        </span>
        <Select
          data-intercom-target={"add-site-mobile-app-select"}
          name="asset_category_selection"
          id="asset_category_selection"
          options={categoryOptions?.sort((a, b) => a.label.localeCompare(b.label))}
          components={{ Option: CategoryCustomOption }}
          isClearable={selectedCategory.length > 0 ?? false}
          classNamePrefix="asset-category-select"
          maxMenuHeight={400}
          menuPortal={document.body}
          menuPosition="fixed"
          required
          onChange={(e) => {
            setSelectedCategory(!e ? [] : [{ label: e?.label ?? '', value: e?.value ?? '', customFields: e?.customFields ?? []}])
          }}
          value={selectedCategory}
          styles={{
            ...(darkMode ? darkModeSelectStyles : {}),
            option: (provided, state) => ({
              ...provided, 
            }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
      </Col>
    </div>
  )
}

export default CategorySelection
